import React, {useEffect, useState} from 'react'
import './WelcomeCardBanner.scss'
import {withRouter} from "react-router-dom";

import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletDataQuery from "../../queries/WalletData";
import {numberFormat} from "../../util";
import {AddWalletData} from "../../Actions";
import {compose} from "redux";
import {connect} from "react-redux";
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";

const arrowWhite = assetUrl+"images/arrow_right.svg";
const rocket = assetUrl+'images/landing-rocket-newUser.png'
const cloud = assetUrl+'images/landing-banner-cloud.png'
const info = assetUrl+"images/info-icon.svg";


const WelcomeCardBanner = (props) => {

	const styleLanding = "landing-"
	const [animateRocket, setAnimateRocket] = useState(false);
	const [walletData, setWalletData] = useState({});
	setTimeout(() => {
		setAnimateRocket(true)
	}, 1000)

	useEffect(() => {
		if(props.logged_in){
			// getWalletData()
			setWalletData(props.walletData);
		}
		return () => {

		};
	}, []);

	const getWalletData = () => {

		let variables = {
			userId: props.user_details.user.id
		}
		fetchQuery(environment, WalletDataQuery, variables)
			.toPromise()
			.then(response => {
				if (response.allWallet !== null && response.allWallet.edges.length > 0) {
					props.setWalletData(response.allWallet.edges[0].node);

					setWalletData(response.allWallet.edges[0].node)

				}
			}, err => {
				console.log(err);

				setWalletData({})

			});
	}
// console.log("wallet",walletData.availableNettWorth)
	const addMoney = () => {
		if(props.logged_in){
			props.currentModal("add");
		} else {
			props.openLoginModal();
		}

	}

	return (
		<>
			<div
				className={styleLanding + "welcome-screen align-items-end d-flex py-1  mt-3 mb-1 justify-content-between"}>
				<div style={{width: "30vh"}} className={"pb-4"}>

					{
						Object.keys(walletData).length > 0 && walletData.availableNettWorth ?
							<>
								<p className={"available-amount-label mb-2"}>NET WORTH</p>
								<div className={'d-flex'}>
									<p className={"available-amount mb-0"}> {numberFormat(walletData.availableNettWorth)}</p>
									<img src={info} alt={"alt"} className={"ml-1"} onClick={()=>props.currentModal("walletData")} style={{width:"16px",height:"16px",marginTop:"18px"}}/>
								</div>

							</>
							:
							<>
								<p className={styleLanding + "welcome my-1"}>Welcome!</p>
								{/*<p className={styleLanding + "welcome-para"}>Setup up Your profile & begin*/}
								{/*	investing!</p>*/}
								<p className={styleLanding + "welcome-para"}>
									Add Money and Buy Your First Neta Share
								</p>
							</>}
							<button className={styleLanding + "welcome-btn py-2  px-2"}
									onClick={addMoney}
							>
								Add Money
								<img src={arrowWhite} alt={"alt"} className={'mx-2'}/>
							</button>
				</div>
				{animateRocket && <div className={"banner-image "}>
					<img src={rocket} alt={"alt"}
					     className={"banner-image-rocket animate__animated animate__fadeInUp delay"}/>
					<img src={cloud} alt={"alt"}
					     className={"banner-image-cloud animate__animated animate__zoomIn delay"}/>
					{/*<img src={bgassets} alt={"alt"} className={"banner-image-assets animate__animated animate__zoomIn delay-2s"}/>*/}
				</div>
				}

			</div>
		</>
	)
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in
});

const mapDispatchToProps = dispatch => ({
	setWalletData: data => dispatch(AddWalletData(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(withRouter(WelcomeCardBanner))

